import { baseUrl } from '../../../network'

export const companyBillUrl = (companyId:number)=> baseUrl + `api/company/${companyId}/bills`
export const singleBillUrl = (billId:number) => baseUrl + `api/bills/${billId}`
export const billsPayBillResourceUrl = (billId:number)=> baseUrl + `api/company/bills/${billId}/pay`
export const billsGetFiltersResourceUrl = (companyId:number)=> baseUrl + `api/company/${companyId}/bills/filters`
export const billsGetOverviewResourceUrl = (companyId:number)=> baseUrl + `api/company/${companyId}/bills/overview`

export const singleBillTransactionFiltersUrl = (billId:number)=> baseUrl + `api/bill/${billId}/transactions/filters`